import { render, staticRenderFns } from "./my_game.vue?vue&type=template&id=6454c13e"
import script from "./my_game.vue?vue&type=script&lang=js"
export * from "./my_game.vue?vue&type=script&lang=js"
import style0 from "./my_game.vue?vue&type=style&index=0&id=6454c13e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports